import { render, staticRenderFns } from "./OrderZapList.vue?vue&type=template&id=577f6b73&scoped=true&"
import script from "./OrderZapList.vue?vue&type=script&lang=js&"
export * from "./OrderZapList.vue?vue&type=script&lang=js&"
import style0 from "./OrderZapList.vue?vue&type=style&index=0&id=577f6b73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577f6b73",
  null
  
)

export default component.exports